export const IconDeletetypes = {
  remesas: "remesas",
  pagos: "pagos",
}
